import React from 'react';
import FormSection from '../../../../common/membershipFormComponents/FormSection';

const MillTypeSection = (props) => {
  return <FormSection sectionColumn={1} {...props} />;
};

export default MillTypeSection;
